module.exports = __webpack_public_path__ + "static/20-ccb0134e5bf820f854ed176b54e5f3f3.png";